import { Visibility, VisibilityOff } from '@mui/icons-material'
import { Alert, Button, IconButton, InputAdornment, Stack, TextField } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { Context } from '../../contexts/Context'
import { getCookie } from '../../services/form/cookies'
import { handleLogin, validateToken } from '../../services/form/login'

const loginFormStyle = {
  margin: '100px auto',
  maxWidth: '300px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '15px'
}

export default function Login () {
  const { handleToken, token } = useContext(Context)
  const [showPassword, setShowPassword] = useState(false)
  const [loginStatus, setLoginStatus] = useState('empty')
  const handleClickPassword = () => setShowPassword(!showPassword)
  const localToken = getCookie('fmtaccount')
  const [form, setForm] = useState({
    username: '',
    password: ''
  })

  useEffect(() => {
    checkToken(localToken)
    // eslint-disable-next-line
  }, [])

  const handleInput = (e) => {
    const { name, value } = e.target
    setForm({ ...form, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    handleLogin(form.username, form.password)
      .then(res => {
        if (res) {
          handleToken(res)
          setLoginStatus(true)
        } else {
          setLoginStatus(false)
        }
      })
  }

  const checkToken = (localToken) => {
    validateToken(localToken)
      .then(res => {
        if (res) {
          handleToken(localToken)
          return <Navigate to='/centers' />
        } else {
          handleToken(null)
        // document.cookie = 'fmtaccount=;path=/'
        }
      })
  }

  if (token) {
    return <Navigate to='/centers' />
  }

  return (
    <div>
      <form style={loginFormStyle} onSubmit={handleSubmit}>
        <TextField
          onChange={handleInput}
          required
          name='username'
          type='text'
          id='outlined-required'
          label='Email'
        />
        <TextField
          onChange={handleInput}
          required
          name='password'
          type={showPassword ? 'text' : 'password'}
          placeholder='password'
          label='Password'
          InputProps={{
            endAdornment: (
              <InputAdornment position='end'>
                <IconButton
                  aria-label='toggle password visibility'
                  onClick={handleClickPassword}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            )
          }}
        />
        {loginStatus === false
          ? <Stack> <Alert sx={{ fontSize: '17px' }} severity={loginStatus ? 'success' : 'error'}> {loginStatus === false ? 'Please Enter correct details' : 'Login Success'} </Alert> </Stack>
          : null}
        <Button
          sx={{ padding: '10px' }}
          type='submit'
          variant='contained'
        >
          Login
        </Button>
      </form>
    </div>
  )
}
